export const baseUri = "https://cutting-fabrik-backend.rebrandyourbusiness.workers.dev/api";
export const local= "en";
